import "./OurOffer.module.css";
import Navigering from "@/reusable_sections/Header";
import ValueCreatingServicesHero from "./sections/ValueCreatingServicesHero";
import OurCompleteRange from "./sections/OurCompleteRange";
import SidfotInfo from "@/reusable_sections/Footer";
export default function OurOfferPage() {
  return <div>
      <Navigering />
      <ValueCreatingServicesHero />
      <OurCompleteRange />
      <SidfotInfo />
    </div>;
}